<template>
  <div class="box-card app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="入库时间">
            <el-date-picker
              v-model="queryParams.inDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="exportExcel"> 导出 </el-button>
      </el-row>
    </el-form>

    <!-- 表格 -->
    <el-table
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
      :data="tableData"
      style="width: 100%"
      border
    >
      <el-table-column prop="name" label="物资/清单" />
      <el-table-column prop="creatorName" label="入库人" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="createTime" label="入库时间" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handlePrint(scope.row)"
            >打印</el-button
          >
          <el-button size="mini" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />

    <!-- 物资详情弹窗 -->
    <view-dialog
      :visible.sync="viewDialogVisible"
      :dialog-title="'物资详情'"
      :tableData="viewForm"
      :columns="viewColumns"
      :total-items="viewTotal"
      :current-page="viewCurrentPage"
      @page-change="fetchViewData"
      @close="viewDialogVisible = false"
    />
  </div>
</template>

<script>
import {
  foodRecordStockInOutPage,
  foodRecordStockInOutPageDetail,
  getfoodExcelDataList,
  print,
} from "@/api/material";
import ViewDialog from "@/components/ViewDialog";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";

export default {
  name: "FoodMaterialTab",
  components: {
    ViewDialog,
    PaginationBar,
  },
  data() {
    return {
      total: 0,
      viewTotal: 0,
      viewDialogVisible: false,
      viewForm: [],
      viewId: "", //查看的ID
      viewPageSize: 5, // 查看弹窗分页大小
      viewCurrentPage: 1, // 查看弹窗当前页
      viewColumns: [
        { label: "商品类型", prop: "categoryName" },
        { label: "物资名称", prop: "name" },
        { label: "单位", prop: "unit" },
        { label: "数量", prop: "num" },
        { label: "结算单价(元)", prop: "singlePrice" },
        { label: "金额", prop: "totalAmount" },
      ],
      tableData: [],
      queryParams: {
        category: "",
        name: "",
        inDateRange: [],
      },
      pageSize: 10,
      currentPage: 1,
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery(page) {
      this.currentPage = page || 1;
      // 根据查询条件获取数据
      foodRecordStockInOutPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 1, //入库
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    fetchViewData(page) {
      this.viewCurrentPage = page;
      this.handleGetView();
    },
    exportExcel() {
      // 导出功能
      getfoodExcelDataList({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 1,
      }).then((res) => {
        downloadFile(
          res.data,
          "食材物资入库记录.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    handlePrint(row) {
      const { name } = row;
      print({
        recordId: row.id,
      }).then((res) => {
        downloadFile(
          res.data,
          `${name || "食材物资"}入库单.xlsx`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        // printXlsxAsStyledHtml(res.data);
      });
    },
    handleGetView() {
      foodRecordStockInOutPageDetail({
        pageNo: this.viewCurrentPage,
        pageSize: this.viewPageSize,
        id: this.viewId,
      }).then((res) => {
        this.viewForm = res.records;
        this.viewTotal = res.total;
        this.viewDialogVisible = true;
      });
    },
    handleView(data) {
      this.viewId = data.id;
      // 处理查看操作，例如打开详情弹窗
      this.handleGetView();
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
